import React from "react"

import { Links } from "config/links"

import { BackgroundImage } from "components/shared/background-img"
import { Box } from "components/shared/box"
import { ClippedBox } from "components/shared/clipped-box/clipped-box"
import { Button } from "components/shared/landing/button"
import { Link } from "components/shared/link"
import { Text } from "components/shared/text"
import { TitleDivider } from "components/shared/title-divider"

import clippedCorners from "utils/clipped-corners"

import styles from "./how-to-get.module.scss"

export function HowToGetSection() {
  return (
    <BackgroundImage imageSrc="/images/pages/bot-3d/how-to-get/bg.png" className="bg-cover bg-no-repeat bg-bottom">
      <Box className="relative md:h-[950px] lg:max-h-[100vh] px-4 md:px-8 mx-auto w-full">
        <Box className="lg:max-w-[472px] mt-12 z-1">
          <Text weight="bold" className="uppercase text-[42px] leading-[48px] lg:text-[70px] lg:leading-[80px]">
            Drop <br />
            for holders
          </Text>
          <Box className="mt-6 md:flex-row lg:flex-col gap-6">
            <Text className="flex-1">
              The only way to create a 3D NFT Cryptobot is to be a holder of the Classic 2017 Cryptobots
            </Text>
            <Text className="flex-1">
              All respective owners will be able to mint a 3D versions of the owned Cryptobots for FREE.
            </Text>
          </Box>
          <Link className="mt-6 mr-auto w-[15rem]" href={Links.OPENSEA_WRAPP} target="_blank" highlightOnHover={false}>
            <Button size="lg" className="mt-4 min-w-[15rem] uppercase">
              Become a holder
            </Button>
          </Link>
        </Box>

        <Box full center className="mt-8 md:mt-0 md:absolute inset-0">
          <ClippedBox
            corners={clippedCorners.lb_rt}
            clipK={"2rem"}
            className={`w-full md:w-auto rounded-box p-[4px] ${styles["video-clipped-box"]}`}
          >
            <ClippedBox
              corners={clippedCorners.lb_rt}
              clipK={"2rem"}
              className="rounded-box p-[2px] bg-space h-0 w-full pb-[100%] md:w-[400px] lg:w-[600px] relative"
            >
              <video
                poster="/images/pages/bot-3d/how-to-get/video-placeholder.png"
                autoPlay
                muted
                loop
                className="w-full"
              >
                <source src="/video/chip.mp4" type="video/mp4" />
              </video>
            </ClippedBox>
          </ClippedBox>
        </Box>

        <Box className="px-4 md:px-8 lg:px-0 md:max-w-[500px] lg:max-w-[472px] my-12 md:my-0 md:absolute bottom-16 left-0 lg:left-[initial] right-0 z-1 gap-6">
          <Text weight="bold" className="uppercase text-[48px] leading-[48px] lg:text-[5rem] lg:leading-[5rem]">
            Free Mint date
          </Text>
          <TitleDivider />
          <Text>The 3D bots will be mintable on a 1:1 basis — the more Cryptobots you have the more 3Ds you get!</Text>
          <Box className="mt-6 mr-auto w-[14rem]">
            <Button size="lg" className="mt-4 uppercase" type="secondary" disabled>
              Mint Now!
            </Button>
          </Box>
        </Box>
      </Box>
    </BackgroundImage>
  )
}
